import { Outlet } from 'react-router-dom'
import { Select } from '@/components/Select'
import { useInstitutionCampaignSelect } from '@/hooks/useInstitutionCampaignSelect'
import { useAuth } from '@/hooks/useAuth'
import { useInstitution } from '@/contexts/InstitutionContext'
import styles from './ClientesTabsLayout.module.css'

export type ClientesLayoutOutletContext = {
  campaignId: number | null
  campaignsLoading: boolean
  hasCampaigns: boolean
  globalAdministration: boolean
}

/**
 * Área Clientes: cabeçalho + seletor de campanha, sem abas (apenas a lista).
 */
export function ClientesTabsLayout() {
  const { guard } = useAuth()
  const { institutionId } = useInstitution()
  const globalAdministration = guard === 'admin' && institutionId === null
  const {
    campaignOptions,
    campaignValue,
    handleCampaignValueChange,
    selectPlaceholder,
    campaignsError,
    persistError,
    isSelectorDisabled,
    campaignId,
    campaignsLoading,
  } = useInstitutionCampaignSelect()

  const headerCampaign = (
    <div className={styles.campaignSelector}>
      <Select
        id="clientes-campanha-select"
        value={campaignValue}
        onChange={handleCampaignValueChange}
        options={campaignOptions}
        placeholder={selectPlaceholder}
        label="Campanha"
        icon="mdi:bullhorn"
        disabled={isSelectorDisabled}
      />
      {campaignsError ? (
        <p className={styles.campaignSelectorError} role="alert">
          {campaignsError}
        </p>
      ) : null}
      {persistError ? (
        <p className={styles.campaignSelectorError} role="alert">
          {persistError}
        </p>
      ) : null}
    </div>
  )

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.headerText}>
          <h1 className={styles.title}>Clientes</h1>
          <p className={styles.subtitle}>
            {globalAdministration
              ? 'Gerencie todos os compradores da plataforma Sortee'
              : 'Gerencie compradores e o relacionamento com sua base'}
          </p>
        </div>
        {!globalAdministration && (
          <div className={styles.headerActionWrap}>{headerCampaign}</div>
        )}
      </header>

      <div className={styles.content}>
        <Outlet
          context={
            {
              campaignId,
              campaignsLoading,
              hasCampaigns: campaignOptions.length > 0,
              globalAdministration,
            } satisfies ClientesLayoutOutletContext
          }
        />
      </div>
    </div>
  )
}
